import { extendTheme } from "@chakra-ui/react";
import {
  CMBalloonEditRequestStyles,
  CMButtonBackStyles,
  CMButtonChangeLanguageStyles,
  CMButtonFormCommentStyles,
  CMButtonPopupSearchConditionCheckboxAndRadioStyles,
  CMButtonPopupSearchConditionCheckboxStyles,
  CMButtonPopupSearchConditionDatalistFreeStyles,
  CMButtonPopupSearchConditionDatalistStyles,
  CMButtonPopupSearchConditionDateRangeStyles,
  CMButtonPopupSearchConditionDatetimeRangeStyles,
  CMButtonPopupSearchConditionMasterStyles,
  CMButtonPopupSearchConditionRadioStyles,
  CMButtonPopupSearchConditionTextStyles,
  CMButtonSearchConditionCheckboxAndRadioStyles,
  CMButtonSearchConditionCheckboxStyles,
  CMButtonSearchConditionDatalistFreeStyles,
  CMButtonSearchConditionDatalistStyles,
  CMButtonSearchConditionDateRangeStyles,
  CMButtonSearchConditionDatetimeRangeStyles,
  CMButtonSearchConditionMasterStyles,
  CMButtonSearchConditionRadioStyles,
  CMButtonSearchConditionStyles,
  CMButtonSearchConditionTextStyles,
  CMCardEmailLogStyles,
  CMCommentBlockInputStyles,
  CMCommentHeaderStyles,
  CMCommentThreadInputStyles,
  CMCommentThreadStyles,
  CMCommentTitleStyles,
  CMCustomDatePickerInputStyles,
  CMDatePickerStyles,
  CMDatetimePickerStyles,
  CMDatetimeTextStyles,
  CMEditRequestThreadStyles,
  CMExtendedMenuStyles,
  CMFileUploadItemStyles,
  CMFileUploadTitleStyles,
  CMFormChangeBadgeStyles,
  CMFormCommentEditButtonStyles,
  CMFormCommentHeaderUserNameStyles,
  CMFormCommentInputStyles,
  CMFormCommentMainStyles,
  CMFormCommentReplyStyles,
  CMFormCommentTextStyles,
  CMFormControlHeaderStyles,
  CMFormFileUploadStyles,
  CMFormInputBaseCheckboxStyles,
  CMFormInputBaseDateStyles,
  CMFormInputBaseDropDownStyles,
  CMFormInputBaseFileAttachableTextAreaStyles,
  CMFormInputBaseNumberStyles,
  CMFormInputBaseRadioStyles,
  CMFormInputBaseSearchAndSelectStyles,
  CMFormInputBaseTextAreaStyles,
  CMFormInputBaseTextStyles,
  CMFormInputBaseTimeStyles,
  CMFormInputBaseYearMonthStyles,
  CMFormInputCheckboxStyles,
  CMFormInputDateStyles,
  CMFormInputDateTimeStyles,
  CMFormInputDropDownStyles,
  CMFormInputFileAttachableTextAreaStyles,
  CMFormInputNumberStyles,
  CMFormInputPasswordStyles,
  CMFormInputRadioStyles,
  CMFormInputSearchAndSelectPopupStyles,
  CMFormInputSearchAndSelectStyles,
  CMFormInputTextAreaStyles,
  CMFormInputTextStyles,
  CMFormInputTimeStyles,
  CMFormInputYearMonthStyles,
  CMFormLoginStyles,
  CMFrameButtonPopupSearchConditionStyles,
  CMFrameCardStyles,
  CMFrameRadioLinkageStyles,
  CMFrameSectionStyles,
  CMIndicatorStatusStyles,
  CMItemEditRequestStyles,
  CMItemFileUploadStyles,
  CMMainCommentBlockItemStyles,
  CMMainCommentBlockStyles,
  CMMessageErrorStyles,
  CMMessageInfoStyles,
  CMModalJsonDifferenceStyles,
  CMModalOptionsCancelStyles,
  CMModalOptionsTwoAndCancelStyles,
  CMPageNumberAndSearchResultStyles,
  CMPaginationStyles,
  CMPopupCommentEditRequestStyles,
  CMProgressStepStyles,
  CMReplyCommentBlockItemStyles,
  CMReplyCommentBlockStyles,
  CMSearchAndSelectDropdownMenuStyles,
  CMSearchAndSelectTextboxStyles,
  CMSearchResultCellDatetimeStyles,
  CMSearchResultCellFrameStyles,
  CMSearchResultCellJsonDiffModalStyles,
  CMSearchResultCellJsonDiffStyles,
  CMSearchResultCellNotificationBadgeStyles,
  CMSearchResultCellNumberStyles,
  CMSearchResultCellReactRouterLinkListStyles,
  CMSearchResultCellReactRouterLinkStyles,
  CMSearchResultCellStyles,
  CMSearchResultCellTextListStyles,
  CMSearchResultCellTextStyles,
  CMSearchResultHeaderStyles,
  CMSearchResultRowStyles,
  CMSearchResultTableStyles,
  CMSectionMultipleCardAddableStyles,
  CMSelectableListItemWithBadgeStyles,
  CMTabMainMenuStyles,
  CMTabSmallListStyles,
  CMTimePickerStyles,
  CMTooltipStyles,
  CMYearMonthPickerStyles,
  CommentBlockItemStyles,
  CommentBlockStyles,
  ConfirmationModalBaseStyles,
  DeleteConfirmationModalStyles,
  DeleteIconButtonStyles,
  DummyTextareaButtonStyles,
  FileAttachableTextboxStyles,
  FileUploadFormRowStyles,
  FormCommentBalloonStyles,
  FormRequiredLabelStyles,
  IconButtonBaseStyles,
  StepItemStyles,
  StepsStyles,
} from "./components";

export * from "./components";
export * from "./hooks";
export * from "./lib";

export const theme = extendTheme({
  components: {
    // # base
    CMDatePickerStyles,
    CMDatetimePickerStyles,
    CMTimePickerStyles,
    CMYearMonthPickerStyles,

    // # button
    DummyTextareaButtonStyles,
    CMButtonBackStyles,

    // # comment
    CommentBlockStyles,
    CMCommentBlockInputStyles,
    CommentBlockItemStyles,
    CMCommentHeaderStyles,
    CMCommentTitleStyles,
    CMMainCommentBlockItemStyles,
    CMMainCommentBlockStyles,
    CMReplyCommentBlockItemStyles,
    CMReplyCommentBlockStyles,
    CMCommentThreadInputStyles,
    CMCommentThreadStyles,
    // ## misc
    FileAttachableTextboxStyles,

    // # control
    CMFormInputBaseTextStyles,
    CMFormInputBaseTextAreaStyles,
    CMFormInputBaseDropDownStyles,
    CMFormInputBaseNumberStyles,
    CMFormInputBaseRadioStyles,
    CMFormInputBaseSearchAndSelectStyles,
    CMFormInputBaseTimeStyles,
    CMFormInputBaseYearMonthStyles,
    CMCustomDatePickerInputStyles,
    CMFormInputBaseDateStyles,
    CMFormInputBaseCheckboxStyles,
    CMFormInputBaseFileAttachableTextAreaStyles,
    CMFormInputFileAttachableTextAreaStyles,
    CMFormFileUploadStyles,
    CMFileUploadTitleStyles,
    // # form
    // ## badge
    CMFormChangeBadgeStyles,
    // ## label
    FormRequiredLabelStyles,

    // ## comment
    // ### button
    CMButtonFormCommentStyles,
    CMFormCommentEditButtonStyles,
    // ### comment
    CMItemEditRequestStyles,
    CMFormCommentMainStyles,
    CMFormCommentReplyStyles,
    CMEditRequestThreadStyles,
    // ### control
    CMFormCommentInputStyles,
    // ### popup
    FormCommentBalloonStyles,
    CMBalloonEditRequestStyles,
    // ### text
    CMFormCommentHeaderUserNameStyles,
    CMFormCommentTextStyles,
    // ## control
    CMFormInputPasswordStyles,
    CMFormControlHeaderStyles,
    CMFormInputTextStyles,
    CMFormInputTextAreaStyles,
    CMFormInputDropDownStyles,
    CMFormInputNumberStyles,
    CMFormInputYearMonthStyles,
    CMFormInputDateStyles,
    CMFormInputDateTimeStyles,
    CMFormInputRadioStyles,
    CMFormInputCheckboxStyles,
    CMFormInputTimeStyles,
    CMItemFileUploadStyles,
    // ## file-upload
    FileUploadFormRowStyles,
    CMFileUploadItemStyles,
    // ## frame
    CMFrameRadioLinkageStyles,
    CMFrameSectionStyles,
    CMFrameCardStyles,
    // ## login
    CMFormLoginStyles,

    // # icon-button
    DeleteIconButtonStyles,
    IconButtonBaseStyles,

    // # input
    CMFormInputSearchAndSelectPopupStyles,

    // # modal
    ConfirmationModalBaseStyles,
    DeleteConfirmationModalStyles,
    CMModalJsonDifferenceStyles,
    CMModalOptionsCancelStyles,
    CMModalOptionsTwoAndCancelStyles,

    // # search
    // ## button
    CMButtonSearchConditionStyles,
    CMButtonSearchConditionCheckboxStyles,
    CMButtonSearchConditionCheckboxAndRadioStyles,
    CMButtonSearchConditionDatalistStyles,
    CMButtonSearchConditionDatalistFreeStyles,
    CMButtonSearchConditionDateRangeStyles,
    CMButtonSearchConditionDatetimeRangeStyles,
    CMButtonSearchConditionMasterStyles,
    CMButtonSearchConditionRadioStyles,
    CMButtonSearchConditionTextStyles,
    // ## button-popup
    CMButtonPopupSearchConditionCheckboxStyles,
    CMButtonPopupSearchConditionCheckboxAndRadioStyles,
    CMButtonPopupSearchConditionDatalistStyles,
    CMButtonPopupSearchConditionDatalistFreeStyles,
    CMButtonPopupSearchConditionRadioStyles,
    CMButtonPopupSearchConditionDateRangeStyles,
    CMButtonPopupSearchConditionDatetimeRangeStyles,
    CMButtonPopupSearchConditionTextStyles,
    CMButtonPopupSearchConditionMasterStyles,
    CMSearchAndSelectTextboxStyles,
    CMSearchAndSelectDropdownMenuStyles,
    CMFrameButtonPopupSearchConditionStyles,
    // ## cell
    CMSearchResultCellStyles,
    CMSearchResultCellDatetimeStyles,
    CMSearchResultCellFrameStyles,
    CMSearchResultCellJsonDiffStyles,
    CMSearchResultCellJsonDiffModalStyles,
    CMSearchResultCellNotificationBadgeStyles,
    CMSearchResultCellNumberStyles,
    CMSearchResultCellReactRouterLinkStyles,
    CMSearchResultCellReactRouterLinkListStyles,
    CMSearchResultCellTextStyles,
    CMSearchResultCellTextListStyles,
    // ## header
    CMSearchResultHeaderStyles,
    // ## row
    CMSearchResultRowStyles,
    // ## table
    CMSearchResultTableStyles,

    // # step
    StepItemStyles,
    StepsStyles,

    // # text
    CMDatetimeTextStyles,

    // # input
    // ## CMFormInputSearchAndSelect
    CMFormInputSearchAndSelectStyles,

    // # message
    CMMessageErrorStyles,
    CMMessageInfoStyles,

    // # page
    // ## page
    CMPaginationStyles,
    CMPageNumberAndSearchResultStyles,

    // # others
    CMButtonChangeLanguageStyles,
    CMCardEmailLogStyles,
    CMTooltipStyles,
    CMProgressStepStyles,
    CMTabMainMenuStyles,
    CMIndicatorStatusStyles,
    CMPopupCommentEditRequestStyles,

    // # tab
    // ## CMTabSmallList
    CMTabSmallListStyles,

    // # menu
    // # CMExtendedMenu
    CMExtendedMenuStyles,

    // # section
    // # CMSectionMultipleCardAddable
    CMSectionMultipleCardAddableStyles,

    // # list
    CMSelectableListItemWithBadgeStyles,
  },
});
